(() => {
  const init = scope => {
    const guides = [...scope.querySelectorAll('[data-how-guide]')];
    if (scope.matches?.('[data-how-guide]')) guides.unshift(scope);
    guides.forEach(guide => {
      if (guide.dataset.howInitialized) return;
      const switcher = guide.querySelector('[data-how-switch]');
      const tabs = [...guide.querySelectorAll('[data-how-tab]')];
      const panels = [...guide.querySelectorAll('[data-how-panel]')];
      if (!switcher || !tabs.length || panels.length !== tabs.length) return;
      guide.dataset.howInitialized = 'true';
      switcher.setAttribute('role', 'tablist');
      tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.howPanel !== tab.dataset.howTab; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(tabs[next], true);
        });
      });
      guide.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-how-panel]');
        const tab = tabs.find(item => item.dataset.howTab === panel?.dataset.howPanel);
        if (tab) select(tab);
      });
      select(tabs[0]);
      guide.classList.add('is-enhanced');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
